import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject, Subject, debounceTime, distinctUntilChanged, map, startWith } from 'rxjs';
import { IChargeMasterModel } from 'src/app/models/Charge_Master_Model/charge-master';
import { ChargeMasterApiService } from 'src/app/services/domain_code/charge-master-api.service';
import { disColData } from '../search-pg-table/search-pg-table.component';

@Component({
    selector: 'app-search-charge-table',
    templateUrl: './search-charge-table.component.html',
    styleUrls: ['./search-charge-table.component.scss', '../master-data.scss']
})
export class SearchChargeTableComponent implements OnInit {
    isEditable: boolean = true;
    selectedCharge: IChargeMasterModel;
    pageLength = 0;
    pageSize = 10;
    pageIndex = 0;
    searchText = new BehaviorSubject<string>('');
    update: boolean = false;


    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator = Object.create(null);
    @ViewChild(MatSort, { static: true }) sort: MatSort = Object.create(null);
    @Input() table_data: MatTableDataSource<IChargeMasterModel>;
    @Input() displayedColumns!: string[];
    @Input() resultsLength!: number;
    @Input() displayedColumnData!: disColData[];
    @Output() pageSizeOptions = new EventEmitter<string>();
    @Output()
    loading = new EventEmitter<boolean>();
    @Output() editData = new EventEmitter<string>();
    defaultErrorObj: any = {};

    @Output()
    clearErrorsOnFormOpen = new EventEmitter();
    @Input()
    chargeList: MatTableDataSource<IChargeMasterModel>;
    @Input()
    RefreshChargeTable = new Subject();


    constructor(private _chargemasterservice: ChargeMasterApiService) { }


    ngOnInit(): void {
        this.refreshChargeList();
        this.RefreshChargeTable.subscribe(item => {
            this.refreshChargeList();
        });

        this.searchText.pipe(
            startWith(''),
            distinctUntilChanged(),
            debounceTime(1000),
            map((searchText) => {
                this.refreshChargeList(this.pageSize, this.pageIndex, searchText);
            })
        ).subscribe();
    }

    /** Announce the change in sort state for assistive technology. */
    announceSortChange(sortState: Sort) {
        this.update = true;
        switch (sortState.direction) {
            case 'asc':
                this.refreshChargeList(this.pageSize, this.pageIndex, '', sortState.active);
                break;

            case 'desc':
                this.refreshChargeList(this.pageSize, this.pageIndex, '', `-${sortState.active}`);
                break;

            default:
                this.refreshChargeList(this.pageSize, this.pageIndex);
        }
    }

    applyFilter(event) {
        this.update = true;
        this.pageIndex = 0;
        this.searchText.next(event);
    }

    actionEdit(element) {
        this.editData.emit(element);
    }

    ngAfterViewInit() {
        if (this.table_data != null || this.table_data != undefined) {
            this.table_data.paginator = this.paginator;
            this.table_data.sort = this.sort;
        }
    }

    refreshChargeList(pageSize = null, pageIndex = null, searchTerm = '', ordering = '') {
        pageSize = pageSize || this.pageSize;
        pageIndex = pageIndex || this.pageIndex;
        this._chargemasterservice.getChargeMaster(pageSize, pageIndex + 1, searchTerm, ordering).subscribe({
            next: response => {
                this.table_data = new MatTableDataSource(response.results);
                this.pageLength = response.count;
                this.loading.emit(false);
                this.update = false;
            },
            error: error => {
                return error;
            }
        })
    }

    pageChanged(event: PageEvent) {
        this.update = true;
        this.pageSize = event.pageSize;
        this.pageIndex = event.pageIndex;
        this.refreshChargeList(this.pageSize, this.pageIndex);
    }
}